// Сквозная лента просмотра входов сообщения. Живёт отдельно от разметки:
// «какие кадры и в каком порядке показывает просмотр» — правило, которое хочется
// проверять само по себе, без рендера плиток.

import type { MessageInputChannelView } from "~/entities/chat";
import type { MediaLightboxItem } from "~/shared/ui/media-lightbox";

export interface MessageInputsLightboxFeed {
    /** Все кадры входов в порядке показа плиток. */
    slides: MediaLightboxItem[];
    /** С какого кадра ленты начинается плитка `[канал][позиция]`. */
    startAt: number[][];
}

/**
 * Строит ленту и позиции плиток за ОДИН проход.
 *
 * Лента одна на всё сообщение: человек смотрит, что реально ушло в генерацию, и
 * должен пролистать входы стрелками, а не закрывать окно ради соседнего.
 * Тип помнится покадрово — у звука нет кадра, и открывать его картинкой нельзя
 * (там плеер), а соседями в одной ленте идут и картинки, и видео.
 */
export function buildInputsLightboxFeed(
    channels: readonly MessageInputChannelView[],
): MessageInputsLightboxFeed {
    const slides: MediaLightboxItem[] = [];
    const startAt: number[][] = [];

    for (const channel of channels) {
        const perItem: number[] = [];
        for (const item of channel.items) {
            perItem.push(slides.length);
            for (const url of item.lightbox) {
                slides.push({ url, type: item.kind ?? "image" });
            }
        }
        startAt.push(perItem);
    }

    return { slides, startAt };
}
